var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-fuzzy-matrix" },
    [
      _vm.loading
        ? _c("Loading")
        : [
            _vm._l(_vm.matrix.categories, function(category) {
              return _c("Category", {
                key: category.id,
                attrs: {
                  category: category,
                  "filter-values": _vm.filterValues
                },
                on: {
                  filterValue: function($event) {
                    return _vm.$emit("filterValue", $event)
                  }
                }
              })
            }),
            _vm._v(" "),
            _vm.filterValues && _vm.filterValues.length > 0
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "d-flex mb-2" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "font-weight-bold font-size-big color-red"
                        },
                        [_vm._v("Aktive Filter")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-3" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.$emit("resetFilterValues")
                              }
                            }
                          },
                          [
                            _c("Icon", { attrs: { icon: "bin" } }),
                            _vm._v(" "),
                            _c("span", { staticClass: "font-size-small" }, [
                              _vm._v("alle Filter löschen")
                            ])
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.filterValues, function(filterValue, i) {
                      return _c(
                        "div",
                        {
                          key: filterValue.id,
                          class: ["p-2", { "bg-color-light-gray": i % 2 === 0 }]
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { md: "3" } }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.rowByValueTypeLabels[filterValue.type]
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { md: "9" } }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.$emit(
                                          "filterValue",
                                          filterValue
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("Icon", {
                                      staticClass: "mr-1",
                                      attrs: { icon: "bin" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(filterValue.label) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }